<script setup lang="ts">
import { vInterpolate } from '@/directives/v-interpolate'
import type { Schemas } from '#shopware'

const props = defineProps<{
    content: Schemas['CmsElementExpandableText']
}>()

const isExpanded = ref(false)

const teaserContent = computed(() => props.content?.config?.teaserContent?.value)
const expandableContent = computed(() => props.content?.config?.expandableContent?.value)
const buttonLabel = computed(() => props.content?.config?.buttonLabel?.value || 'Weiterlesen')
</script>

<template>
    <div class="h-full flex flex-col m-auto p-4">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div
            v-if="teaserContent"
            v-interpolate
            class="prose max-w-full"
            v-html="teaserContent"
        />
        <button
            v-if="expandableContent"
            class="self-start underline cursor-pointer my-3 text-left flex items-center gap-1"
            @click="isExpanded = !isExpanded"
        >
            <MiscIcon
                v-if="!isExpanded"
                name="chevron-right"
                size="md"
                aria-hidden="true"
            />
            <MiscIcon
                v-else
                name="chevron-down"
                size="md"
                aria-hidden="true"
            />
            {{ buttonLabel }}
        </button>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div
            v-if="expandableContent"
            v-interpolate
            class="prose max-w-full overflow-hidden"
            :class="isExpanded ? 'max-h-none' : 'max-h-0'"
            v-html="expandableContent"
        />
    </div>
</template>
